const starSVG = (color = '#ffffff') => `
<svg width="10" height="9" viewBox="0 0 10 9" fill="none" xmlns="http://www.w3.org/2000/svg">
<path 
    d="M4.82065 0.363397C4.89402 0.214748 5.10598 0.214748 5.17935 0.363397L6.42293 2.88317C6.45206 2.9422 6.50837 2.98311 6.57352 2.99258L9.35425 3.39664C9.51829 3.42048 9.5838 3.62207 9.46509 3.73778L7.45293 5.69915C7.4058 5.7451 7.38429 5.8113 7.39542 5.87618L7.87042 8.64567C7.89844 8.80905 7.72696 8.93365 7.58023 8.85651L5.09307 7.54893C5.0348 7.5183 4.9652 7.5183 4.90693 7.54893L2.41977 8.85651C2.27304 8.93365 2.10156 8.80905 2.12958 8.64567L2.60458 5.87618C2.61571 5.8113 2.5942 5.7451 2.54707 5.69915L0.534908 3.73778C0.416204 3.62207 0.481706 3.42048 0.64575 3.39664L3.42648 2.99258C3.49163 2.98311 3.54794 2.9422 3.57707 2.88317L4.82065 0.363397Z" 
    fill="${color}"
/>
</svg>

`

export default starSVG;



// WEBPACK FOOTER //
// ./src/Components/inlineSVGs/starSVG.js